'use client';

import { c as _c } from "react/compiler-runtime";
import { assert } from '@core/utils';
import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { UnauthInfiniteQueryOptions } from '@/api';
import { isAffiliateHotDealGone } from '../../_utils/resolveAffiliateClick';
import type { MerchantProductCardProps } from '../_components/MerchantProductCard';
import { MERCHANT_PRODUCT_PAGE_SIZE } from '../_constants';
import { resolveIdentifiedHotDeal } from '../_utils/resolveHotDeal';
export const useAffiliateMerchantProducts = merchantCode => {
  const $ = _c(14);
  let t0;
  if ($[0] !== merchantCode) {
    t0 = UnauthInfiniteQueryOptions["get:/wello/v1/allows/affiliate/products/{merchantCode}"]({
      path: {
        merchantCode
      },
      query: {
        page: 0,
        size: MERCHANT_PRODUCT_PAGE_SIZE
      }
    });
    $[0] = merchantCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const infiniteQueryOptions = t0;
  const {
    queryFn
  } = infiniteQueryOptions;
  assert(typeof queryFn === "function");
  let t1;
  if ($[2] !== queryFn) {
    t1 = async context => {
      ;
      try {
        return await queryFn(context);
      } catch (t2) {
        const error = t2;
        if (isAffiliateHotDealGone(error)) {
          return {
            context: undefined
          };
        }
        throw error;
      }
    };
    $[2] = queryFn;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== infiniteQueryOptions || $[5] !== t1) {
    t2 = {
      ...infiniteQueryOptions,
      queryFn: t1,
      initialPageParam: 0,
      getNextPageParam: _temp
    };
    $[4] = infiniteQueryOptions;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const query = useSuspenseInfiniteQuery(t2);
  let t3;
  if ($[7] !== query.data.pages) {
    t3 = query.data.pages.flatMap(_temp4);
    $[7] = query.data.pages;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const products = t3;
  let t4;
  if ($[9] !== products || $[10] !== query.fetchNextPage || $[11] !== query.hasNextPage || $[12] !== query.isFetchingNextPage) {
    t4 = {
      products,
      fetchNextPage: query.fetchNextPage,
      hasNextPage: query.hasNextPage,
      isFetchingNextPage: query.isFetchingNextPage
    };
    $[9] = products;
    $[10] = query.fetchNextPage;
    $[11] = query.hasNextPage;
    $[12] = query.isFetchingNextPage;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
function _temp(lastPage) {
  const response = lastPage.context;
  if (!response) {
    return;
  }
  const loadedCount = (response.page + 1) * response.size;
  return loadedCount < response.totalCount ? response.page + 1 : undefined;
}
function _temp2(identified) {
  return {
    hotDeal: identified,
    giftProduct: undefined
  };
}
function _temp3(t0) {
  const {
    hotDeal,
    giftProduct
  } = t0;
  if (hotDeal) {
    return resolveIdentifiedHotDeal(hotDeal).map(_temp2);
  }
  return giftProduct ? [{
    hotDeal: undefined,
    giftProduct
  }] : [];
}
function _temp4(page) {
  return (page.context?.contents ?? []).flatMap(_temp3);
}